import React from "react";
import { PageHeader } from "./About";
import { CTABanner } from "../components/Sections";
import { SuccessStories } from "../components/NewSections";

const Testimonials = () => (
  <main>
    <PageHeader title="Testimonials" subtitle="WHAT OUR CLIENTS SAY" />
    <SuccessStories />
    <CTABanner />
  </main>
);

export default Testimonials;
